export default "__VITE_ASSET__BWYEl6mk__"